const toggleMinimalBodyClass = (isMinimal: boolean) => {
    const minimalBodyClass = 'dhf-page--minimal';
    const bodyEl = document.querySelector('body');
    const bodyHasClass = bodyEl?.classList.contains(minimalBodyClass);
    if (isMinimal) {
        if (bodyHasClass) return;
        return bodyEl?.classList.add(minimalBodyClass);
    } else {
        if (!bodyHasClass) return;
        return bodyEl?.classList.remove(minimalBodyClass);
    }
};

export default {
    toggleMinimalBodyClass,
};
